import { makeAutoObservable } from "mobx"
import ReportSection from "./ReportSection"
import ReportInfluencerPerformance from "./ReportInfluencerPerformance"
export default class CampaignReport {

  constructor(campaignReport={}) {
    this.id = campaignReport.id
    this.campaign_id = campaignReport.campaign_id
    this.campaign_name = campaignReport.campaign_name || ''
    this.survey_link_title = campaignReport.survey_link_title || ''
    this.survey_link = campaignReport.survey_link || ''
    this.start_date = campaignReport.start_date || ''
    this.end_date = campaignReport.end_date || ''
    this.general_visible = !!campaignReport.general_visible
    this.campaign_overview_visible = !!campaignReport.campaign_overview_visible
    this.important_metrics_visible = !!campaignReport.important_metrics_visible
    this.influencer_overview_visible = !!campaignReport.influencer_overview_visible
    this.learning_visible = !!campaignReport.learning_visible
    this.survey_link_visible = !!campaignReport.survey_link_visible
    this.contact_us_visible = !!campaignReport.contact_us_visible
    this.timeframe_visible = !!campaignReport.timeframe_visible
    this.timeline_visible = !!campaignReport.timeline_visible
    this.audience_metrics_visible = !!campaignReport.audience_metrics_visible
    this.influencer_amount = campaignReport.influencer_amount || 0
    this.influencer_amount_reason = campaignReport.influencer_amount_reason || ''
    this.upload_amount = campaignReport.upload_amount || 0
    this.upload_amount_reason = campaignReport.upload_amount_reason || ''
    this.gross_reach = campaignReport.gross_reach || 0
    this.gross_reach_reason = campaignReport.gross_reach_reason || ''
    this.net_reach = campaignReport.net_reach || 0
    this.net_reach_reason = campaignReport.net_reach_reason || ''
    this.impression = campaignReport.impression || 0
    this.impression_reason = campaignReport.impression_reason || ''
    this.influencer_budget = campaignReport.influencer_budget || 0
    this.influencer_budget_reason = campaignReport.influencer_budget_reason || ''
    this.social_ads_budget = campaignReport.social_ads_budget || 0
    this.social_ads_budget_reason = campaignReport.social_ads_budget_reason || ''
    this.organic_impressions = campaignReport.organic_impressions || 0
    this.organic_reach = campaignReport.organic_reach || 0
    this.organic_engagement_rate = campaignReport.organic_engagement_rate || 0
    this.organic_top_performing_post_id = campaignReport.organic_top_performing_post_id || ''
    this.organic_comment = campaignReport.organic_comment || ''
    this.paid_impressions = campaignReport.paid_impressions || 0
    this.paid_reach = campaignReport.paid_reach || 0
    this.paid_revenue_generated = campaignReport.paid_revenue_generated || 0
    this.paid_clicks = campaignReport.paid_clicks || 0
    this.paid_return_of_invesment_post_id = campaignReport.paid_return_of_invesment_post_id || ''
    this.paid_spend_overview = campaignReport.paid_spend_overview || 0
    this.conversions = campaignReport.conversions || 0
    this.paid_comment = campaignReport.paid_comment || ''
    this.revenue_generated = campaignReport.revenue_generated || 0
    this.total_spend = campaignReport.total_spend || 0
    this.roi_visible = !!campaignReport.roi_visible
    this.paid_roi_visible = !!campaignReport.paid_roi_visible
    this.conversion_rate_visible = !!campaignReport.conversion_rate_visible
    this.audience_gender_visible = !!campaignReport.audience_gender_visible
    this.audience_age_visible = !!campaignReport.audience_age_visible
    this.audience_countries_visible = !!campaignReport.audience_countries_visible
    this.audience_cities_visible = !!campaignReport.audience_cities_visible
    this.created_at = campaignReport.created_at || ''
    this.updated_at = campaignReport.updated_at || ''

    this.default_campaign_overview_sections = campaignReport.default_campaign_overview_sections?.map(reportSection => new ReportSection(reportSection)) || []
    this.custom_campaign_overview_sections = campaignReport.custom_campaign_overview_sections?.map(reportSection => new ReportSection(reportSection)) || []
    this.learning_sections = campaignReport.learning_sections?.map(reportSection => new ReportSection(reportSection)) || []
    this.report_influencer_performances = campaignReport.report_influencer_performances?.map(reportInfluencerPerformance => new ReportInfluencerPerformance(reportInfluencerPerformance)) || []
    makeAutoObservable(this)
  }
}
